import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import useRecursiveTimeout from "@insite/client-framework/Common/Hooks/useRecursiveTimeout";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { Disabled } from "@insite/mobius/Swatch";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Search from "@tecumseh/MobiusOverrides/Icons/Search";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { typography } from "@tecumseh/theme/styleguide";
import useEmblaCarousel from "embla-carousel-react";
import parse from "html-react-parser";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import styled, { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    fields: {
        img: string;
        image1: string;
        title: string;
        para: string;
        midText: string;
        lowerText1: string;
        lowerText2: string;
        lowerText3: string;
        image: string;
        buttonSelect: "doubleButton" | "singleButton";
        path1: LinkFieldValue;
        path2: LinkFieldValue;
        path3: LinkFieldValue;
        specialMessage: string;
        button1OpenInNewTab: boolean;
        button2OpenInNewTab: boolean;
        button3OpenInNewTab: boolean;
    };
}

const enum fields {
    divisions = "divisions",
    button1OpenInNewTab = "openInNewTab",
    button2OpenInNewTab = "openInNewTab",
    button3OpenInNewTab = "openInNewTab",
}

interface OwnProps extends WidgetProps {
    fields: {
        maintitle: string;
        image: string;
        members: any;
        [fields.divisions]: Memberlist[];
    };
    maxNumberOfColumns: number;
}
type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    ContentImg?: InjectableCss;
    imgwrapper?: InjectableCss;
    container?: InjectableCss;
    twrapper?: TypographyProps;
    hwrapper?: InjectableCss;
    buttonlabel1?: InjectableCss;
    parent?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPREV?: InjectableCss;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNEXT?: InjectableCss;
    button?: LinkPresentationProps;
    buttonWrapper?: InjectableCss;
    title?: TypographyProps;
    parawrapper?: InjectableCss;
    buttonlabel2?: InjectableCss;
    parentContainer?: InjectableCss;
    aTagIconContainer?: InjectableCss;
    specialAlert?: InjectableCss;
    buttonlabel3?: InjectableCss;
    practice?: InjectableCss;
    searchIcon?: IconPresentationProps;
}

export const imgstyle: Imgstyle = {
    ContentImg: {
        css: css`
            width: 100%;
            img {
                border: 1px solid ${getColor("common.border")};
                object-fit: cover;
                aspect-ratio: 3.6/2.2 !important;
                border-radius: 5px;
            }
            &::after {
                content: "";
                position: absolute;
                width: 17px;
                right: -2px;
                bottom: -9px;
                height: 40px;
                border-left: 1px solid ${getColor("common.border")};
                background-color: ${COLORS.background.whiteSaltpan};
                border-image-slice: 10%;
                transform: rotateZ(45deg);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;

                        img {
                            object-fit: cover;
                            aspect-ratio: 3/1.6 !important;
                        }
                    `,
                    css`
                        width: 100%;

                        img {
                            object-fit: cover;
                            aspect-ratio: 3.2/1.6 !important;
                        }
                    `,
                    css`
                        width: 100%;

                        img {
                            object-fit: cover;
                            aspect-ratio: 3.2/1.6 !important;
                        }
                    `,

                    null,
                    null,
                ])}
        `,
    },

    buttonPREV: {
        css: css`
            /* background-color: ${COLORS.background.secondaryNavyThree}; */
            background-color: ${getColor("secondary")};
            padding: 0;
            border-radius: 50%;
            height: 35px;
            width: 35px;
            border: none;
            svg {
                color: white;
            }
            &:hover {
                opacity: 1;
                background-color: ${getColor("secondary")};
            }
            &:disabled,
            button[disabled] {
                background-color: ${COLORS.background.darkGray};
                color: ${COLORS.dimGray};
            }
        `,
    },
    buttonNEXT: {
        css: css`
            background-color: ${getColor("secondary")};
            padding: 0;
            border-radius: 50%;
            height: 35px;
            width: 35px;
            border: none;
            svg {
                color: white;
            }
            &:hover {
                opacity: 1;
                background-color: ${getColor("secondary")};
            }
            &:disabled,
            button[disabled] {
                background-color: ${COLORS.background.darkGray};
                color: ${COLORS.dimGray};
            }
        `,
    },
    title: {
        variant: "h2",
        css: css`
            opacity: 1;
            color: ${getColor("primary")};
            font-family: ${TYPOGRAPHY.fontFamily.barlow};
            /* font-size: ${TYPOGRAPHY.size.mLarge}; */
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallish};
            text-align: center;
            text-transform: uppercase;
            padding-top: 21px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.largest};
                        margin-left: 80px;
                        margin-right: 80px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    aTagIconContainer: {
        css: css`
            padding-left: 10px;
            padding-right: 5px;
        `,
    },
    imgwrapper: {
        css: css``,
    },
    prevArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 0;
            transform: translate(-50%, -50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 35%;
                        left: 40px;
                    `,
                    css`
                        left: 45px;
                        top: 40%;
                    `,
                    css`
                        left: 45px;
                        top: 40%;
                    `,
                    css`
                        left: 45px;
                        top: 45%;
                    `,

                    null,
                ])};
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 50%;
            right: -35px;
            transform: translate(-50%, -50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 35%;
                        right: 5px;
                    `,
                    css`
                        right: -10px;
                        top: 40%;
                    `,
                    css`
                        right: -10px;
                        top: 40%;
                    `,
                    css`
                        right: -10px;
                        top: 45%;
                    `,

                    null,
                ])};
        `,
    },
    specialAlert: {
        css: css`
            position: absolute;
            bottom: 20px;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            max-height: 35px;
            padding: 11px;
            border-radius: 0px 20.5px 20.5px 0px;
            opacity: 1;
            /* background-color: ${COLORS.background.primaryBlue}; */
            background-color: ${getColor("primary")};
            color: ${COLORS.white};
            font-size: ${TYPOGRAPHY.size.tiny};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smaller};
            text-align: center;
            line-height: ${TYPOGRAPHY.lineHeight.vSmallestbase};
            text-transform: uppercase;
        `,
    },
    twrapper: {
        variant: "h4",
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            opacity: 1;
            /* color: ${COLORS.secondaryNavyOne}; */
            color: ${getColor("secondary")};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.small};
            text-align: left;
            text-transform: uppercase;
            margin-top: 11px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${TYPOGRAPHY.size.large};
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.base};
                    `,
                    null,
                    null,
                ])}
        `,
    },
    parawrapper: {
        css: css`
            opacity: 1;
            color: ${COLORS.black};
            font-size: ${TYPOGRAPHY.size.small};
            font-weight: ${TYPOGRAPHY.weight.base};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
            text-align: left;
            margin-bottom: 11px;
            margin-top: 5px;
        `,
    },
    buttonlabel1: {
        css: css`
            width: auto;
            border-radius: 25px 0 0 25px;
            background-color: ${getColor("warning")};
            padding: 4px 6px;
            &:hover {
                background-color: ${getColor("warning.contrast")};
            }
            span {
                color: ${getColor("info.contrast")}!important;
                font-size: ${TYPOGRAPHY.size.smallest} !important;
                /* padding: 4px 11px; */
                opacity: 1;
                color: ${COLORS.black};
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                font-style: normal;
                letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
                text-align: left;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                            font-weight: ${TYPOGRAPHY.weight.baseBold} !important;
                            margin-left: -2px;
                            > svg {
                            }
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            text-align: center;
                        }
                    `,
                    null,
                ])}
        `,
    },
    buttonlabel3: {
        css: css`
            width: auto;
            border-radius: 25px 25px 25px 25px;
            background-color: ${getColor("warning")};
            padding: 4px 11px;
            &:hover {
                background-color: ${getColor("warning.contrast")};
            }
            &::after {
                content: "";
                width: 11px;
                margin-left: 10px !important;
                height: 11px;
                border-radius: 50%;
                display: inline-block;
                position: relative;
                margin: auto;
                border-radius: 5.499547px;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.638631) inset;
                opacity: 1;
                background-color: ${COLORS.background.whiteSmoke};
            }
            span {
                color: ${getColor("info.contrast")}!important;
                font-size: ${TYPOGRAPHY.size.smallest} !important;
                opacity: 1;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                font-style: normal;
                letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
                text-align: left;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    buttonlabel2: {
        css: css`
            display: flex;
            width: auto;
            border: 1px solid ${COLORS.normalGray};
            border-radius: 0 25px 25px 0;
            background: ${getColor("danger.contrast")};
            font-size: ${TYPOGRAPHY.size.smallest};
            padding: 4px 6px;
            &:hover {
                &::after {
                    background: ${COLORS.yellow};
                    border: 0.25px solid rgba(17, 41, 69, 0.22);
                    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
                }
            }
            span {
                color: ${getColor("success.contrast")} !important;
                font-size: ${TYPOGRAPHY.size.smallest} !important;
                opacity: 1;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                font-style: normal;
                letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
                text-align: left;
                svg {
                    color: ${getColor("success.contrast")} !important;
                }
            }
            &::after {
                content: "";
                width: 11px;
                margin-left: 13px !important;
                height: 11px;
                border-radius: 50%;
                display: inline-block;
                position: relative;
                margin: auto;
                left: -6px;
                border-radius: 5.499547px;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgb(0 0 0 / 64%) inset;
                opacity: 1;
                background-color: ${COLORS.background.whiteSmoke};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                            > svg {
                            }
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    searchIcon: {
        size: 12,
        src: Search,
        color: "info.contrast",
        css: css`
            margin-right: 5px;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            gap: 4px;
            margin: 10px 0px;
        `,
    },
    parentContainer: {
        css: css`
            max-width: 364px;
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        max-width: 290px;
                    `,

                    null,
                ])}
        `,
    },
    parent: {
        css: css`
            display: flex;
            margin-left: 23px;
            margin-right: 23px;
            gap: 30px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        gap: 25px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
        `,
    },
    practice: {
        css: css`
            position: relative;
            padding: 30px 0;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 29px;
                    `,
                    css``,
                    css`
                        padding: 30px;
                    `,
                    css`
                        padding: 30px;
                    `,
                    null,
                ])};
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            position: relative;
        `,
    },
    main: {
        css: css`
            position: relative;
        `,
    },
};

const styles = imgstyle;

export const TECHomepageArticleCarousel: FC<Props> = ({ fields, maxNumberOfColumns = 3, theme, shellContext }) => {
    const afterCarousel = createRef<HTMLSpanElement>();

    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else {
            localSlidesToScroll = 3;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);

    useEffect(() => {
        if (!embla || !fields.divisions || fields.divisions.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            watchDrag: draggable,
            loop: false,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.divisions]);

    if (!fields.divisions || fields.divisions.length === 0) {
        return null;
    }

    const links1 = useGetLinks(fields.divisions, o => o.fields.path1);
    const links2 = useGetLinks(fields.divisions, o => o.fields.path2);
    const links3 = useGetLinks(fields.divisions, o => o.fields.path3);

    return (
        <>
            <StyledWrapper
                css={css`
                    border-radius: 7px;
                    opacity: 1;
                    /* margin-top: 50px !important; */
                    margin-bottom: 50px !important;
                    background-color: ${COLORS.background.whiteSaltpan};
                    max-width: 1200px;
                    margin: auto;
                `}
            >
                <StyledWrapper {...styles.main}>
                    {fields.divisions.length > 1 && (
                        <StyledWrapper {...styles.prevArrowWrapper}>
                            <Button
                                {...styles.buttonPREV}
                                onClick={() => {
                                    embla && embla.scrollPrev();
                                }}
                                disabled={!canScrollPrev}
                            >
                                <ButtonIcon src={ChevronLeft} />
                            </Button>
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.nextArrowWrapper}>
                        <Button
                            {...styles.buttonNEXT}
                            onClick={() => {
                                embla && embla.scrollNext();
                            }}
                            disabled={!canScrollNext}
                        >
                            <ButtonIcon src={ChevronRight} />
                        </Button>
                    </StyledWrapper>
                    <Typography as="h2" {...styles.title}>
                        {" "}
                        {fields.maintitle}
                    </Typography>
                    <StyledWrapper {...styles.practice}>
                        <StyledWrapper {...styles.container} ref={emblaRef}>
                            <StyledWrapper {...styles.parent}>
                                {fields.divisions?.map((division, index) => {
                                    return (
                                        <StyledWrapper
                                            {...styles.parentContainer}
                                            key={index}
                                            style={{ width: `calc(100% / ${slidesToScroll})` }}
                                        >
                                            <StyledWrapper
                                                css={css`
                                                    width: 100%;
                                                    height: 100%;
                                                    position: relative;
                                                    display: flex;
                                                    flex-direction: column;
                                                `}
                                            >
                                                <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                    <LazyImage {...styles.ContentImg} src={division.fields.img} />
                                                    {division.fields.specialMessage && (
                                                        <StyledWrapper {...styles.specialAlert}>
                                                            {division.fields.specialMessage}
                                                        </StyledWrapper>
                                                    )}
                                                </StyledWrapper>
                                                <Typography as="h4" {...styles.twrapper}>
                                                    {division.fields.title}
                                                </Typography>
                                                <StyledWrapper {...styles.parawrapper}>
                                                    {division.fields.para}
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.buttonWrapper}>
                                                    {division.fields.lowerText1 && (
                                                        <StyledWrapper {...styles.buttonlabel1}>
                                                            <StyledWrapper {...styles.aTagIconContainer}>
                                                                <Link
                                                                    target={
                                                                        division.fields.button1OpenInNewTab
                                                                            ? "_blank"
                                                                            : undefined
                                                                    }
                                                                    href={links1[index].url}
                                                                    {...styles.button}
                                                                >
                                                                    <Icon {...styles.searchIcon} />
                                                                    {division.fields.lowerText1}
                                                                </Link>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    )}
                                                    {division.fields.lowerText2 && (
                                                        <StyledWrapper {...styles.buttonlabel2}>
                                                            <Link
                                                                target={
                                                                    division.fields.button2OpenInNewTab
                                                                        ? "_blank"
                                                                        : undefined
                                                                }
                                                                href={links2[index].url}
                                                                {...styles.button}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="21"
                                                                    height="12"
                                                                    viewBox="0 0 11 12"
                                                                >
                                                                    <g
                                                                        fill="none"
                                                                        fillRule="evenodd"
                                                                        stroke="none"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="1"
                                                                    >
                                                                        <g
                                                                            stroke="currentcolor"
                                                                            transform="translate(1.889 1.54)"
                                                                        >
                                                                            <path
                                                                                strokeLinecap="round"
                                                                                d="M0 .896v7.171c0 .495.401.897.896.897h5.379a.896.896 0 00.896-.897V2.842a.896.896 0 00-.27-.64L4.911.255A.896.896 0 004.285 0H.896A.896.896 0 000 .896z"
                                                                            ></path>
                                                                            <path d="M4.482 0v1.793c0 .495.401.896.896.896h1.793"></path>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                                {division.fields.lowerText2}
                                                            </Link>
                                                        </StyledWrapper>
                                                    )}
                                                    {division.fields.lowerText3 && (
                                                        <StyledWrapper {...styles.buttonlabel3}>
                                                            <Link
                                                                target={
                                                                    division.fields.button3OpenInNewTab
                                                                        ? "_blank"
                                                                        : undefined
                                                                }
                                                                href={links3[index].url}
                                                                {...styles.button}
                                                            >
                                                                {division.fields.lowerText3}
                                                            </Link>
                                                        </StyledWrapper>
                                                    )}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    );
                                })}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(TECHomepageArticleCarousel)),
    definition: {
        group: "Basic",
        displayName: "TECHomepageArticleCarousel",
        fieldDefinitions: [
            {
                name: "maintitle",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Image",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "specialMessage",
                        displayName: "Special message",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "para",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "buttonSelect",
                        displayName: "Button Select",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "Double Button", value: "doubleButton" },
                            { displayName: "Single Button", value: "singleButton" },
                        ],
                        defaultValue: "doubleButton",
                        hideEmptyOption: true,
                    },
                    {
                        name: "lowerText1",
                        displayName: "Button text 1",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "path1",
                        displayName: "Button Link 1",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "button1OpenInNewTab",
                        displayName: "Open in new tab",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "lowerText2",
                        displayName: "Button text 2",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "path2",
                        displayName: "Button Link 2",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "button2OpenInNewTab",
                        displayName: "Open in new tab",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: widget => widget.fields.buttonSelect === "doubleButton",
                    },
                    {
                        name: "lowerText3",
                        displayName: "Button text 3",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: widget => widget.fields.buttonSelect === "singleButton",
                    },
                    {
                        name: "path3",
                        displayName: "Button Link 3",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        isVisible: widget => widget.fields.buttonSelect === "singleButton",
                    },
                    {
                        name: "button3OpenInNewTab",
                        displayName: "Open in new tab",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: widget => widget.fields.buttonSelect === "singleButton",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
